import { ComponentPropsWithRef, memo } from 'react';

export const SIndexTableCell = memo(function SIndexTableCell({ children, ...props }: SIndexTableCellProps) {
    return <s-table-cell {...props}>{children}</s-table-cell>;
});

export type SIndexTableCellProps = ComponentPropsWithRef<'s-table-cell'> & {
    children: React.ReactNode;
};
